import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import { BfnStatus } from '@/models/Befehlsnachricht'
import { tfStatusStyle } from '@/features/befehlsnachrichten/utils/befehlsnachricht-status'

type ScrollProgressContextType = {
  progressStyle: string
  updateProgressStyle: (
    newStatus: BfnStatus,
    newManuellWiderrufen?: boolean
  ) => void
}
const ScrollProgressColorContext = createContext<
  ScrollProgressContextType | undefined
>(undefined)

export default function ScrollProgressColorProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [progressStyle, setProgressStyle] = useState<string>(
    'bg-red-500 dark:bg-red-600'
  ) // Standardfarbe

  const updateProgressStyle = useCallback(
    (newStatus: BfnStatus, newManuellWiderrufen?: boolean) => {
      const statusStyle = tfStatusStyle(newStatus, newManuellWiderrufen)
      setProgressStyle(
        `${statusStyle.backgroundColor} ${statusStyle.darkBackgroundColor}`
      )
    },
    []
  )

  const value = useMemo(
    () => ({
      progressStyle,
      updateProgressStyle
    }),
    [progressStyle, updateProgressStyle]
  )

  return (
    <ScrollProgressColorContext.Provider value={value}>
      {children}
    </ScrollProgressColorContext.Provider>
  )
}

export const useScrollProgressColor = () => {
  const context = useContext(ScrollProgressColorContext)
  if (!context)
    throw new Error('useScrollProgressColor must be used within Provider')
  return context
}
